import { Component, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Subject, fromEvent } from 'rxjs';
import { takeUntil, throttleTime } from 'rxjs/operators';
import * as moment from 'moment';

@Component({
  selector: 'medical-appointment-queues-period-list',
  templateUrl: './queues-period-list.html',
  styles: [` 
    `]
})
export class MedicalAppointmentQueuesPeriodListComponent {

  @ViewChild('qsContainer') qsContainer: ElementRef | undefined;
  @ViewChild('qsScrollable') qsScrollable: ElementRef | undefined;

  @Output() queueSelected: EventEmitter<any> = new EventEmitter<any>();

  @Input() isloading = false;
  @Input() set queues(value: any[]) {
    this.isloading = false;

    if (!value) {
      this.model = [];
      return;
    }

    value.forEach((o: any) => {
      o.dayOfWeek = this.getDayOfWeek(o.date);
      o.monthGenShort = this.getMonthGenShort(o.date);
    });

    this.model = value;//.splice(0, 7);
    this.evaluateVars();
    setTimeout(() => { this.evaluateVars(); }, 200);
  }


  public model: any[] = [];
  public sizes = { 
    qsContainerWidth: 0,
    qsContainerHight: 0,

    btnsQueuesWidth: 0,
    btnsQueuesHeight: 0,
    btnsQueuesScrollLeft: 0,

    evaluatedWidth: this.model.length * 113,
    maxOffset: 0,
    moveStep: 100,

    isWider: false
  };

  private readonly unsubscribe$ = new Subject<void>();


  constructor() {
    //fromEvent(window, 'resize').pipe(throttleTime(100)).subscribe(() => { this.evaluateVars(); });
    fromEvent(window, 'resize').pipe(takeUntil(this.unsubscribe$)).subscribe(() => { this.evaluateVars(); });
  }


  ngAfterViewInit() { setTimeout(() => { this.evaluateVars(); }, 200); }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }


  public move(direction: string) {

    direction = direction == 'forward' ? 'forward' : 'back';

    this.sizes.btnsQueuesScrollLeft = direction == 'forward'
      ? this.sizes.btnsQueuesScrollLeft + this.sizes.moveStep > this.sizes.maxOffset
        ? this.sizes.maxOffset
        : this.sizes.btnsQueuesScrollLeft + this.sizes.moveStep
      : this.sizes.btnsQueuesScrollLeft - this.sizes.moveStep < 10
        ? 0
        : this.sizes.btnsQueuesScrollLeft - this.sizes.moveStep

    this.qsScrollable?.nativeElement.scrollTo({ left: this.sizes.btnsQueuesScrollLeft, behavior: 'smooth' });
  }


  private evaluateVars() {

    let qsRect = this.qsContainer?.nativeElement.getBoundingClientRect() 
      ?? { 
        width: this.qsContainer?.nativeElement.offsetWidth, 
        height: this.qsContainer?.nativeElement.offsetHeight 
      };
    
    let evaluatedWidth = this.model.length * 112.8;
    let isWider = evaluatedWidth > qsRect.width;
    this.qsScrollable?.nativeElement.scrollTo({ left: 0 });

    let sizes = {

      qsContainerWidth: qsRect.width,
      qsContainerHight: qsRect.height,

      btnsQueuesWidth: isWider ? qsRect.width - 2 * 35 : evaluatedWidth,
      btnsQueuesHeight: qsRect.height - 20,
      btnsQueuesScrollLeft: 0,

      evaluatedWidth: evaluatedWidth,
      maxOffset: evaluatedWidth + 2 * 35 - qsRect.width,
      moveStep: qsRect.width * 0.7,

      isWider: isWider
    };
    this.sizes = sizes;
  }

  private getDayOfWeek(date: Date): string {

    if (date.getTime() == moment().add(1, 'days').startOf("day").toDate().getTime()) {
      return 'завтра';
    }


    let day = date.getDay();

    switch (day) {
      case 1: 
        return 'пн';
      case 2: 
        return 'вт';
      case 3: 
        return 'ср';
      case 4: 
        return 'чт';
      case 5: 
        return 'пт';
      case 6: 
        return 'сб';
      default: 
        return 'нд';
    }
  }

  private getMonthGenShort(date: Date): string {
    let month = date.getMonth() + 1;

    switch (month) {
      case 1: 
        return 'січ';
      case 2: 
        return 'лют';
      case 3: 
        return 'берез';
      case 4: 
        return 'квіт';
      case 5: 
        return 'трав';
      case 6: 
        return 'черв';
      case 7: 
        return 'лип';
      case 8: 
        return 'серп';
      case 9: 
        return 'верес';
      case 10: 
        return 'жовт';
      case 11: 
        return 'лист';
      case 12: 
        return 'груд';
      default: 
        return '';
    }

  }
}
